module.exports = __webpack_public_path__ + "../resources/img/ic_show.448ddd96.svg";